import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable vue/no-mutating-props */
import _ from 'lodash';
import configCard from './config-card.vue';
import CreativeDirectionDialog from '@/components/CreativeDirectionDialog/index.vue';
import { fetchCreativeInfoList } from '@/api/creative/info';

export default {
  components: {
    configCard: configCard,
    CreativeDirectionDialog: CreativeDirectionDialog
  },
  props: {
    formConfig: {
      type: Object,
      required: true
    },
    schemeValue: {
      type: Object,
      default: function _default() {}
    },
    demand: {
      type: Object,
      default: function _default() {}
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    updateFeatureTag: {
      type: Function
    }
  },
  data: function data() {
    return {
      formValue: {
        creative_id: '',
        creative_text: ''
      },
      dialog: {
        config: {
          loading: false,
          title: '',
          visible: false
        },
        value: {
          id: '',
          name: '',
          app_id: '',
          material_type: '',
          enable_i18n: ''
        }
      },
      options: []
    };
  },

  computed: {
    formItemList: function formItemList() {
      var _this = this;

      var list = [{
        visible: !this.readOnly,
        label: '创意方向：',
        type: 'select',
        prop: 'creative_id',
        rules: [{
          required: true,
          message: '请选择创意方向',
          trigger: 'change'
        }],
        params: {
          style: 'width:400px',
          filterable: true,
          disabled: false,
          clearable: true,
          remote: true,
          options: this.options,
          'remote-method': this.remoteData,
          placeholder: '请选择创意方向',
          handleChange: function handleChange(val) {
            _this.getCreativeInfo(val);
          }
        }
      }, {
        visible: this.readOnly,
        label: '创意方向：',
        type: 'plain-text',
        prop: 'creative_text'
      }];
      return list;
    },
    creationType: function creationType() {
      try {
        // 1: playable, 2: endcard
        return this.schemeValue.demand.creation_tasks[0].creation_type;
      } catch (error) {
        return 0;
      }
    }
  },
  watch: {
    'formValue.creative_id': function formValueCreative_id(val) {
      val && (this.schemeValue.creative_id = val);
    },
    'schemeValue.fetch_data': function schemeValueFetch_data(val) {
      if (val) {
        this.fillForm();
      }
    }
  },
  methods: {
    validate: function validate(cb) {
      return this.$refs.form.validate(cb);
    },
    fillForm: function fillForm() {
      if (!this.options.length) {
        this.remoteData('');
      }
      if (this.schemeValue.creative_id) {
        this.formValue.creative_id = this.schemeValue.creative_id;
        this.formValue.creative_text = this.schemeValue.creative_name;
      }
    },
    showDialog: function showDialog() {
      this.dialog.config.visible = true;
      this.dialog.config.title = '添加创意方向';
      this.dialog.value.id = '';
      this.dialog.value.name = this.demand.app_names || '';
      this.dialog.value.app_id = '';
      this.dialog.value.material_type = '';
      this.dialog.value.enable_i18n = 1;
    },
    operateSuccess: function operateSuccess(data) {
      this.formValue.creative_id = data.id;
      this.formValue.creative_text = data.name;
      this.schemeValue.category_id = data.material_type;
      this.schemeValue.enable_i18n = data.enable_i18n;
      this.options.push({
        value: data.id,
        label: data.name,
        material_type: data.material_type
      });
    },
    getCreativeInfo: function getCreativeInfo(id) {
      var item = this.options.find(function (e) {
        return e.value === id;
      });
      if (item) {
        this.updateFeatureTag(item.tag_ids || '');
        this.schemeValue.category_id = item.material_type;
        this.schemeValue.enable_i18n = item.enable_i18n;
        this.formValue.creative_text = item.name;
        this.$emit('update-action', item.actions);
      }
    },
    remoteData: function remoteData(query) {
      var _this2 = this;

      fetchCreativeInfoList({
        page: 1,
        page_size: 15,
        search_field: 'name',
        keyword: query,
        material_types: '1,2,3,4,5',
        active_status: 'enabled'
      }).then(function (res) {
        _this2.options = (_.get(res, 'data.data.list') || []).map(function (item) {
          return _extends({}, item, {
            value: item.id,
            label: item.name
          });
        });
      }).catch(function () {
        _this2.options = [];
      });
    }
  },
  mounted: function mounted() {
    this.fillForm();
  }
};